import React from 'react';
import { istMonthToDate, orderedDays } from './closeBooksRules';

const defaultInput =
  'px-3 py-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-md focus:ring-indigo-500 focus:border-indigo-500';
const labelCls = 'block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1';

interface Props {
  /** `YYYY-MM-DD` IST days, '' for open-ended. */
  from: string;
  to: string;
  onChange: (range: { from: string; to: string }) => void;
  /** What the days filter on, e.g. "Invoice date". */
  label: string;
  inputClassName?: string;
}

/**
 * A From/To pair of IST days. The page decides how they go on the wire: invoice dates
 * are IST days and are sent as they are; UTC timestamps go through istDaysToServerUtc.
 */
const IstDateRange: React.FC<Props> = ({ from, to, onChange, label, inputClassName = defaultInput }) => (
  <>
    <div>
      <label className={labelCls}>{label} from (IST)</label>
      <input
        type="date"
        aria-label={`${label} from (IST)`}
        value={from}
        max={to || undefined}
        onChange={(e) => onChange(orderedDays(e.target.value, to))}
        className={inputClassName}
      />
    </div>
    <div>
      <label className={labelCls}>To (IST)</label>
      <input
        type="date"
        aria-label={`${label} to (IST)`}
        value={to}
        min={from || undefined}
        onChange={(e) => onChange(orderedDays(from, e.target.value))}
        className={inputClassName}
      />
    </div>
    <button
      type="button"
      onClick={() => onChange(istMonthToDate())}
      className="self-end px-3 py-2 text-sm text-indigo-600 hover:text-indigo-800 dark:text-indigo-400 dark:hover:text-indigo-300"
    >
      This month
    </button>
    {(from || to) && (
      <button
        type="button"
        onClick={() => onChange({ from: '', to: '' })}
        className="self-end px-3 py-2 text-sm text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white"
      >
        Clear dates
      </button>
    )}
  </>
);

export default IstDateRange;
